module.exports = __webpack_public_path__ + "static/img/13.5c7ceab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/13.jpg
// module id = mwz8
// module chunks = 0